import { PublicSharePolicy } from "./PublicSharePolicy";
import { useState } from "react";
import { useIntl } from "react-intl";
import { BoxHeader } from "@/components/design/BoxHeader";
import { KpiBadge } from "@/components/design/KpiBadge";
import { SegmentedControl } from "@/components/design/SegmentedControl";
import { AnonymousAccessIcon } from "./AnonymousAccessIcon";

export function AccessAnonymousGroupPanel() {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const [tab, setTab] = useState("visitors");
  return <section id="groups-anonymous-detail" className="box min-w-0 bg-surface p-6" aria-label={t("admin.groups.anonymous.title")}>
    <BoxHeader wrap title={<span className="flex items-center gap-3"><AnonymousAccessIcon />{t("admin.groups.anonymous.title")}</span>}
      right={<KpiBadge tone="muted">{t("admin.groups.anonymous.fixed")}</KpiBadge>} />
    <p className="mb-6 text-smycles-body text-ink">{t("admin.groups.anonymous.intro")}</p>
    <PublicSharePolicy />
    <SegmentedControl id="groups-anonymous-sections" className="mb-6" value={tab} onChange={setTab}
      aria-label={t("admin.groups.sections")} options={[
        { value: "visitors", label: t("admin.groups.anonymous.visitors") },
        { value: "visibility", label: t("admin.groups.anonymous.visibility") },
        { value: "roles", label: t("admin.groups.rolesTab") },
      ]} />
    <div className="space-y-4 text-smycles-body text-ink">
      {tab === "visitors" && <>
        <p>{t("admin.groups.anonymous.members")}</p>
        <div aria-hidden="true" className="pointer-events-none flex justify-end p-4 select-none text-ink/[0.05]">
          <span className="block size-36 -rotate-12 [&>svg]:size-full"><AnonymousAccessIcon /></span>
        </div>
      </>}
      {tab === "visibility" && <>
        <p>{t("admin.groups.anonymous.publicContent")}</p>
        <p>{t("admin.groups.anonymous.privateContent")}</p>
      </>}
      {tab === "roles" && <p>{t("admin.groups.anonymous.roles")}</p>}
    </div>
    <p className="mt-6 border-t border-ink/10 pt-4 text-smycles-meta text-ink-muted">{t("admin.groups.anonymous.sparkLogin")}</p>
  </section>;
}
